import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const CorrosionControl = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Corrosion Control"
    videos={[
      "https://www.youtube.com/embed/l7G1F-uxgUo",
      "https://www.youtube.com/embed/wRPlBjKFc1I",
      "https://www.youtube.com/embed/XNfKdS82EaY",
      "https://www.youtube.com/embed/BO9aOypYmss",
      "https://www.youtube.com/embed/hdaVgptDQAc"
    ]}
    takeaways={[
      { text: "Cathodic Protection Method related questions are frequently asked." },
      { text: "Learn all the correction control method along with diagram." },
      { text: "Computational methodologies mostly not asked in paper." }
    ]}
    questions={[
      "Explain the available techniques which prevents corrosion of a metal by turning the method into a cathode.",
      "Illustrate with a schematic diagram the principle of impressed current cathodic protection.",
      "Discuss any five factors that influence the corrosion.",
      "A galvanised iron pipe used in water line is getting corroded at the junction where the pipes coming out from the ground. Explain the phenomenon of corrosion using a neat diagram."
    ]}
    exampleVideos={[]}
  />
);
}

export default CorrosionControl;
